var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.272 14.92c.359.4.97.443 1.391.064l.064-.064 5.184-5.669c.358-.421.316-1.032-.063-1.37-.4-.337-1.012-.315-1.37.064l-3.498 3.793V.97a.98.98 0 00-.97-.97.98.98 0 00-.97.97v10.747L5.586 7.903c-.359-.4-.97-.422-1.391-.042-.422.358-.422.969-.042 1.39l5.12 5.67zm9.779 1.918H.969a.98.98 0 00-.969.97c0 .526.443.969.97.969h18.06a.98.98 0 00.97-.97c.02-.526-.422-.969-.949-.969z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.0c0c1d70dd4ea20d4ffd8bf6281978a2.svg";
export { ForwardRef as ReactComponent };